import { DotsThreeIcon as PhosphorDotsThreeIcon } from "@phosphor-icons/react/dist/ssr/DotsThree";

import { createAppIcon } from "@/components/createAppIcon";

export const MoreIcon = /* @__PURE__ */ createAppIcon(PhosphorDotsThreeIcon);
